module.exports = __webpack_public_path__ + "img/avatar4.3395d3e7.png";